/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Last_Admin_ProtectedInputs */

const fr_error_last_admin_protected = /** @type {(inputs: Error_Last_Admin_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C’est le dernier administrateur actif. Promouvez quelqu’un d’autre d’abord.`)
};

const en_error_last_admin_protected = /** @type {(inputs: Error_Last_Admin_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the last active administrator. Promote someone else first.`)
};

/**
* | output |
* | --- |
* | "This is the last active administrator. Promote someone else first." |
*
* @param {Error_Last_Admin_ProtectedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_last_admin_protected = /** @type {((inputs?: Error_Last_Admin_ProtectedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Last_Admin_ProtectedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_last_admin_protected(inputs)
	return fr_error_last_admin_protected(inputs)
});